// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3ta8A","additionalInfo":"AgreementModal_additionalInfo__21Ydh"};